<template>
  <v-app-bar
    :class="{ 'header-home': $route.path === '/' }"
    :color="$route.path === '/' ? 'transparent' : 'primary'"
    :height="mdAndDown ? '114px' : '132px'"
    flat
    :absolute="$route.path === '/'"
  >
    <v-container class="py-0">
      <v-sheet
        width="100%"
        height="100%"
        color="transparent"
        class="d-flex justify-space-between align-center"
      >
        <router-link to="/">
          <img
            v-if="informations.img"
            :src="files + informations.img + '?resize=1&h=84'"
            :alt="informations.name"
            class="d-block"
            :height="mdAndDown ? '70px' : '84px'"
          />
        </router-link>

        <div class="d-flex flex-column align-end justify-center">
          <div
            v-if="
              contact.email ||
              (contact.address && contact.address.link) ||
              social
            "
            class="d-flex justify-end"
          >
            <v-btn
              v-if="contact.email"
              :href="contact.email.link"
              :target="contact.email.target"
              height="38px"
              width="38px"
              icon
            >
              <v-icon color="white" size="15"> fa-envelope </v-icon>
            </v-btn>

            <v-btn
              v-if="contact.address && contact.address.link"
              :href="contact.address.link"
              :target="contact.address.target"
              height="38px"
              width="38px"
              icon
            >
              <v-icon color="white" size="15"> fa-map-marker-alt </v-icon>
            </v-btn>

            <v-btn
              :href="link"
              target="_blank"
              icon
              height="38px"
              width="38px"
              v-for="({ link, target, icon }, keySocial) in social"
              :key="keySocial"
            >
              <v-icon color="white" size="15">
                {{ icon }}
              </v-icon>
            </v-btn>
          </div>

          <div>
            <div
              v-for="({ text, props, dropdown }, keyMenu) in menu"
              :key="keyMenu"
              class="d-inline-flex"
            >
              <v-btn
                v-if="!dropdown"
                class="
                  text-body-2 text-lg-body-1 text-uppercase
                  font-weight-bold font-italic
                  px-1 px-lg-3
                  py-3 py-lg-5
                  nav-link
                "
                exact
                v-bind="props"
                :target="props.href ? '_blank' : '_self'"
                active-class="nav-link-active"
                min-width="auto"
                height="auto"
                depressed
                tile
                text
              >
                <span class="font-secondary">
                  {{ text }}
                </span>
              </v-btn>

              <v-menu v-else offset-y tile>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="
                      text-body-2 text-lg-body-1 text-uppercase
                      font-weight-bold font-italic
                      px-1 px-lg-3
                      py-3 py-lg-5
                      nav-link
                    "
                    active-class="nav-link-active"
                    min-width="auto"
                    height="auto"
                    depressed
                    tile
                    text
                  >
                    <span class="font-secondary">
                      {{ text }}
                    </span>
                    <v-icon class="ml-3" size="12"> fa-caret-down </v-icon>
                  </v-btn>
                </template>
                <v-list class="primary" tile>
                  <v-list-item
                    v-for="(item, keyDropdown) in dropdown"
                    :key="keyDropdown"
                    v-bind="item.props"
                    :target="item.props.href ? '_blank' : '_self'"
                  >
                    <v-list-item-title class="white--text">
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
        </div>
      </v-sheet>
    </v-container>
  </v-app-bar>
</template>

<script>
import { getTelLinkFromPhone } from "../../../utils/getTelLinkFromPhone";
import { getSocial } from "../../../utils/getSocial";
import { getContact } from "../../../utils/getContact";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this.informations);
    },
    contact() {
      return getContact(this.informations);
    },
    mdAndDown() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
  },
  methods: {
    getTelLinkFromPhone,
  },
};
</script>

<style lang="scss" scoped>
.header-home {
  &:before {
    background: rgb(0, 0, 0) !important;
    background: -moz-linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.5) 30%,
      rgba(255, 255, 255, 0) 100%
    ) !important;
    background: -webkit-linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.5) 30%,
      rgba(255, 255, 255, 0) 100%
    ) !important;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.5) 30%,
      rgba(255, 255, 255, 0) 100%
    ) !important;
    bottom: -120px;
    content: "";
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#006633",endColorstr="#ffffff",GradientType=1) !important;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
}

.nav-link {
  color: white !important;
  position: relative;
  text-decoration: none;
  transition: all 0.1s linear;

  &:before {
    opacity: 0 !important;
  }

  &:after {
    background-color: transparent;
    bottom: -17px;
    content: "";
    height: 3px;
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    transition: all 0.1s linear;
  }

  &:hover,
  &.nav-link-active {
    color: var(--v-secondary-base) !important;
  }

  &.nav-link-active {
    &:after {
      background-color: var(--v-secondary-base) !important;
    }
  }
}
</style>
